/* eslint-disable array-callback-return */
import { Form, Input } from "reactstrap";
import { SVG } from "../../AbstractElements";
import { SearchBoho } from "../../Constant";
import SearchSuggestionList from "./SearchSuggestionList";
import { useState } from "react";
import { MenuInterface, SubMenuInterface } from "../../Type/HeaderType";
import { H_MENU } from "../../Data/Sidebar/HorizontalMenu";

const Searchbar = () => {
  const [suggestionOpen, setSuggestionOpen] = useState<boolean>(false);
  const [suggestion, setSuggestion] = useState([]);
  const [searchValue, setSearchValue] = useState<string | undefined>("");

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchKey = e.target.value.toLowerCase();
    setSearchValue(searchKey) 

    if (searchKey !== "") {
      document.body.classList.add("offcanvas");
      let icon: string | undefined;
      let suggestionArray: MenuInterface[] | SubMenuInterface[] | [] | any = [];
      let updatedList: MenuInterface | SubMenuInterface;

      const deepSearchFun = (menuItem: MenuInterface | SubMenuInterface, searchKeyValue: string, mainTitle: string) => {
        if (menuItem.title.toLowerCase().includes(searchKeyValue) && menuItem.url) {
          updatedList = { ...menuItem, mainTitle, icon };
          suggestionArray.push(updatedList);
        }
        if (!menuItem.menu) return;

        menuItem.menu.map((mainSubItem: SubMenuInterface) => {
          if (!mainSubItem.icon) {
            icon = menuItem.icon1;
          }
          deepSearchFun(mainSubItem, searchKeyValue, mainTitle);
        });
      };
      H_MENU.map((mainItem) => {
        mainItem.menu.map((data) => {
          const mainTitle = data.title;
          deepSearchFun(data, searchKey, mainTitle);
        });
      });
      setSuggestion(suggestionArray);
      setSuggestionOpen(true);
    }

    if (searchKey === "") {
      setSuggestionOpen(false);
      setSuggestion([]);
      document.body.classList.remove("offcanvas");
    }
  };

  return (
    <Form className="form-inline search-full" action="#" method="get">
      <div className="form-group w-100">
        <div className="Typeahead Typeahead--twitterUsers">
          <div className="u-posRelative">
            <Input className="demo-input Typeahead-input form-control-plaintext w-100" type="text" placeholder={SearchBoho} onChange={(e) => handleSearch(e)} value={searchValue} />
            <SVG className="search-bg svg-color" iconId="search" />
          </div>
          <div className={`Typeahead-menu theme-scrollbar ${suggestionOpen ? "is-open" : ""}`}>
            <SearchSuggestionList setSuggestionOpen={setSuggestionOpen} suggestion={suggestion} setSearchValue={setSearchValue} />
          </div>
        </div>
      </div>
    </Form>
  );
};

export default Searchbar;
